import React from 'react';
import { VendorCard, VendorCardProps } from './VendorCard';

interface VendorListProps {
  vendors: VendorCardProps[];
}

export const VendorList: React.FC<VendorListProps> = ({ vendors }) => {
  return (
    <div className="my-2 w-full">
      <div className="grid grid-cols-1 gap-3 app-lg:grid-cols-2">
        {vendors.map((vendor, index) => (
          <VendorCard
            key={index}
            {...vendor}
          />
        ))}
      </div>
    </div>
  );
};
